import { useTranslation } from 'react-i18next';
import { AddBundleToBasket, Cancel } from 'autogen/translation-keys/trans-website-basket-minimumsalesquantity';
import { BuyBundleNow, BuyNow } from 'autogen/translation-keys/trans-website-shared-buttons';
import { ButtonWithIcon, ButtonWithSpinner } from 'components/Button';
import useConfirmationQuickView from 'components/ConfirmationQuickView/shared/hooks';
import Icon from 'components/Icon';
import { format } from 'modules/helpers/strings';
import type { ProductActionProps } from '../../shared/types';
import { useAddToBasket } from '../AddProduct/action';
import addMinimumQuantityProduct from './action';

export function AddMinimumQuantityProductButton({
    params,
    trackingInfo,
    minimumQuantity,
    children,
    ...restProps
}: ProductActionProps['BuyMinimumNow']) {
    const { t } = useTranslation();
    const [, toggle] = useConfirmationQuickView();

    const clickToAddBasket = useAddToBasket(params, trackingInfo);

    return (
        <ButtonWithSpinner
            onClick={() =>
                addMinimumQuantityProduct({
                    params,
                    trackingInfo,
                    toggle,
                    handleConfirm: clickToAddBasket,
                    confirmText: t(AddBundleToBasket),
                    denyText: t(Cancel)
                })
            }
            type="button"
            {...restProps}
        >
            {children || (minimumQuantity && format(t(BuyBundleNow))(minimumQuantity)) || t(BuyNow)}
        </ButtonWithSpinner>
    );
}

export function AddMinimumQuantityProductButtonCompact({
    params,
    trackingInfo,
    minimumQuantity,
    ...restProps
}: ProductActionProps['BuyMinimumNow']) {
    const { t } = useTranslation();
    const [, toggle] = useConfirmationQuickView();

    const clickToAddBasket = useAddToBasket(params, trackingInfo);

    return (
        <ButtonWithIcon
            icon={<Icon type="BasketPlus" size={16} fill="currentColor" />}
            onClick={() =>
                addMinimumQuantityProduct({
                    params,
                    trackingInfo,
                    toggle,
                    handleConfirm: clickToAddBasket,
                    confirmText: t(AddBundleToBasket),
                    denyText: t(Cancel)
                })
            }
            type="button"
            aria-label={minimumQuantity ? format(t(BuyBundleNow))(minimumQuantity) : t(BuyNow)}
            {...restProps}
        />
    );
}

export default Object.assign(AddMinimumQuantityProductButton, {
    Compact: AddMinimumQuantityProductButtonCompact
});
